import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { AreaSelectComponent } from './area-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        AreaSelectComponent
    ],
    exports: [
        AreaSelectComponent
    ]
})
export class AreaSelectModule { }
